import { useFormContext } from "react-hook-form";
import { ControlledInput } from "@dune/ui";
import { MoaFormData, useMoaUsersFieldArray } from "./useMoaForm";

interface MoaFormProps {
	isSociety?: boolean;
	disabled?: boolean;
}

export const MoaForm = ({ disabled, isSociety = false }: MoaFormProps) => {
	const form = useFormContext<MoaFormData>();
	const { control } = form;
	const { fields } = useMoaUsersFieldArray(control);

	return !isSociety ? (
		fields.map((field, index) => (
			<div key={field.id} className="flex flex-col gap-4">
				<div className="flex gap-4">
					<ControlledInput
						name={`moaUsers.${index}.moaLastname`}
						control={control}
						label="Nom"
						disabled={disabled}
					/>
					<ControlledInput
						name={`moaUsers.${index}.moaFirstname`}
						control={control}
						label="Prénom"
						disabled={disabled}
					/>
				</div>
				<>
					<div className="flex flex-row gap-4 w-full">
						<ControlledInput
							control={control}
							name={`moaUsers.${index}.streetNumber`}
							label="Numéro de rue"
							disabled={disabled}
						/>
						<ControlledInput
							control={control}
							name={`moaUsers.${index}.streetName`}
							label="Nom de rue"
							disabled={disabled}
						/>
					</div>

					<div className="flex flex-row gap-4 w-full">
						<ControlledInput
							control={control}
							name={`moaUsers.${index}.postalCode`}
							label="Code postal"
							disabled={disabled}
						/>
						<ControlledInput
							control={control}
							name={`moaUsers.${index}.city`}
							label="Ville"
							disabled={disabled}
						/>
					</div>
				</>
			</div>
		))
	) : (
		<>
			<ControlledInput
				control={control}
				name="siren"
				label="SIREN/SIRET"
				maxLength={14}
				disabled={disabled}
			/>
			<ControlledInput
				control={control}
				name="denomination"
				label="Raison sociale"
				disabled={disabled}
			/>

			<>
				<div className="flex flex-row gap-4 w-full">
					<ControlledInput
						control={control}
						name="streetNumber"
						label="Numéro de rue"
						disabled={disabled}
					/>
					<ControlledInput
						control={control}
						name="streetName"
						label="Nom de rue"
						disabled={disabled}
					/>
				</div>

				<div className="flex flex-row gap-4 w-full">
					<ControlledInput
						control={control}
						name="postalCode"
						label="Code postal"
						disabled={disabled}
					/>
					<ControlledInput
						control={control}
						name="city"
						label="Ville"
						disabled={disabled}
					/>
				</div>
			</>
		</>
	);
};
